import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Result } from '../../models/result.model';
import { SUPRIMIR_ALERTA_ERRO } from '../../alerts/interceptors/error.interceptors';
import { SessaoUsuario } from '../models/sessao-usuario.model';
import { SessaoStore } from '../store/sessao.store';

@Injectable({ providedIn: 'root' })
export class SessaoService {
  private readonly http = inject(HttpClient);
  private readonly router = inject(Router);
  private readonly store = inject(SessaoStore);
  private readonly url = `${environment.apiUrl.replace(/\/$/, '')}/api/sessoes`;

  entrar(usuario: string | null, senha: string | null): Observable<Result<SessaoUsuario>> {
    return this.http.post<Result<SessaoUsuario>>(this.url, { usuario, senha }, {
      context: new HttpContext().set(SUPRIMIR_ALERTA_ERRO, true)
    }).pipe(tap(resposta => {
      if (resposta.isSuccess && resposta.data) this.store.abrir(resposta.data);
    }));
  }

  encerrarSessao(): void {
    this.store.limpar();
    void this.router.navigateByUrl('/login');
  }
}
